import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { VehicleVisualsService } from './vehicle-visuals.service';

angular.module('app-lite.vehicle-visuals', [])
  .service('vehicleVisualsApi', downgradeInjectable(VehicleVisualsService));
